// useScrollToTop.js
import { useCallback } from 'react';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import react,{useEffect, useState} from 'react'
export const UseScrollToTop = () => {


    const [scrollPosition, setScrollPosition] = useState(false);

    const handleScroll = () => {
        const position = window.scrollY;
        console.log(position)

        if(position > 400) setScrollPosition(true)
        if(position < 400) setScrollPosition(false)
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);



    const scrollToTop = useCallback(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, []);

    return(
        <>
        {/* <div id="loader-wrapper" style={{display: scrollPosition ? 'block':'none'}}>
            <div id="loader"></div>
        </div> */}
        
            <button className='scroll-top-btn' style={{display: scrollPosition ? 'block':'none'}} onClick={scrollToTop}><ArrowUpwardIcon/></button>
        </>
    )



};
